import type React from "react"

interface AssessmentCardProps {
  title: string
  description: string
  tags: Array<{ label: string; variant: string }>
  duration: string
  questionCount: number
  backgroundColor: string
  borderColor: string
  icon?: React.ReactNode
  buttonText?: string
  onStart: () => void
}

export const AssessmentCard: React.FC<AssessmentCardProps> = ({
  title,
  description,
  tags,
  duration,
  questionCount,
  backgroundColor,
  borderColor,
  icon,
  buttonText = "Start Assessment",
  onStart,
}) => {
  return (
    <div className={`overflow-hidden relative rounded-2xl p-6 border-2 ${backgroundColor} ${borderColor} transition-all duration-300 hover:shadow-lg min-h-[280px]`}>
      {/* Icon taking 50% space in bottom right corner */}
      <div className="absolute  top-2/4 -right-12 w-3/4 h-3/4 flex items-end justify-end p-4 opacity-90">
        <div className="w-full h-full flex items-end justify-end">
          {icon}
        </div>
      </div>

      <div className="relative z-10 h-full flex flex-col">
        <div className="flex-1">
          <div className="flex items-start justify-between mb-4">
            <div className="flex-1 pr-8">
              <h3 className="text-xl font-bold text-slate-900 mb-2">{title}</h3>
              <p className="text-slate-600 mb-4">{description}</p>
            </div>
          </div>

          <div className="flex flex-wrap gap-2 mb-4">
            {tags.map((tag, index) => (
              <span
                key={index}
                className={`px-3 py-1 rounded-full text-xs font-medium ${
                  tag.variant === "science"
                    ? "bg-red-100 text-red-700"
                    : tag.variant === "art"
                    ? "bg-indigo-100 text-indigo-700"
                    : tag.variant === "math"
                    ? "bg-emerald-100 text-emerald-700"
                    : tag.variant === "personality"
                    ? "bg-rose-100 text-rose-700"
                    : tag.variant === "technology"
                    ? "bg-blue-100 text-blue-700"
                    : tag.variant === "nature"
                    ? "bg-lime-100 text-lime-700"
                    : tag.variant === "logic"
                    ? "bg-purple-100 text-purple-700"
                    : tag.variant === "social"
                    ? "bg-pink-100 text-pink-700"
                    : "bg-slate-100 text-slate-700"
                }`}
              >
                {tag.label}
              </span>
            ))}
          </div>

          <div className="flex items-center justify-between text-sm text-slate-600 mb-4">
            <span>{duration} <br/> {questionCount} questions</span>
          </div>
        </div>

        <button
          onClick={onStart}
          className="w-48 py-3 bg-slate-50 border-2 border-slate-300 text-slate-700 rounded-xl font-semibold hover:bg-slate-50 hover:border-slate-400 transition-all duration-200 relative z-20"
        >
          {buttonText}
        </button>
      </div>
    </div>
  )
}